import styled from "styled-components";

export const Userareaname = styled.div`
  font-family: "BukraAlt_Bold";
  color: #a1a1a1;
  font-size: 12px;
  display: flex;
`;
